import {createStore, combineReducers, applyMiddleware, compose} from "redux";
import monthItemsReducer from '../reducers/monthitems';
import itemsReducer from '../reducers/items';
import notificationsReducer from '../reducers/notifications';
import filtersReducer from '../reducers/filters';
import malfunctionsReducer from '../reducers/malfunctions';
import authReducer from '../reducers/auth';
import userReducer from '../reducers/user';
import thunk from 'redux-thunk';

const persistedState = localStorage.getItem('persistState') ?
    JSON.parse(localStorage.getItem('persistState')) : {};

const composeEnhancers =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }) : compose;

export default () => {
    return createStore(
        combineReducers({
                monthItems: monthItemsReducer,
                items: itemsReducer,
                filters: filtersReducer,
                notifications: notificationsReducer,
                malfunctions: malfunctionsReducer,
                auth: authReducer,
                user: userReducer
            }
        ),
        persistedState,
        composeEnhancers(applyMiddleware(thunk))
    );
};



// WEBPACK FOOTER //
// ./src/store/store.js